import { connect } from "react-redux";

import { changeErrorLogModelStateAction, getErrorLog } from "../../../Engine/ActionCreators/ErrorLogActionCreators";
import {
    setPanelActiveTab,
    setPanelState,
    setWidePanel,
} from "../../../Engine/ActionCreators/HiddenPanelActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../withResolvePaths";
import { setHiddenOrgName } from "../../ValueEditors/INN/Store/INNActions";

import { Panel } from "./Panel";
import { PanelTabType, PanelType } from "./PanelTypes";

const mapStateToProps = (state: FullFormState) => ({
    isPopupPanel: state.formVisualState.isPopupPanel ?? false,
    modelChanged: state.errorLog.modelChangedAfterCheck,
    isHideOrgName: state.formVisualState.isHideOrgName,
    isWidePanel: state.formVisualState.isWidePanel,
    panelState: state.formVisualState.panelState,
    errorLog: state.errorLog.form,
    errorLogWasRequested: state.errorLog.form && state.errorLog.form.errorLogWasRequested,
    counterEnabled: state.errorLog.form && state.errorLog.form.counterEnabled,
    embeddedLogEnabled: Boolean(state.settings.embeddedLogEnabled),
    activeTab: state.formVisualState.panelActiveTab,
    useExtendedErrorLog: state.settings.useExtendedErrorLog,
    isReadOnly: state.settings.isReadOnly,
    canCheckByPopd: state.settings.canCheckByPopd,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    getErrorLog: () => dispatch(getErrorLog),
    setWidePanel: (isWidePanel: boolean) => dispatch(setWidePanel(isWidePanel)),
    setPanelState: (panelState: PanelType) => dispatch(setPanelState(panelState)),
    setHiddenOrgName: (isHidden: boolean) => dispatch(setHiddenOrgName(isHidden)),
    onChangeActiveTab: (tab: PanelTabType) => dispatch(setPanelActiveTab(tab)),
    onChangeModelState: (modelChanged: boolean) => dispatch(changeErrorLogModelStateAction(modelChanged)),
});

export const PanelContainer = withResolvePaths(connect(mapStateToProps, mapDispatchToProps)(Panel));
